<h2 lvrPadding [padHorizontal]="32" [padVertical]="0">{{ 'user.position_share.edit' | transloco }}</h2>
<form class="form-container" [formGroup]="form" lvrAutoSave="user" [entityId]="draftId()" [autoLoad]="false">
	<!-- Position Share Field -->
	<lvr-field [label]="'base.field.positionShare' | transloco | appendAsterisk">
		@let positionShareCtrl = form.get('share');
		<mat-form-field lvrInput [lvrError]="hasError(positionShareCtrl, 'min', 'max', 'required')">
			<input
				matInput
				type="number"
				step="0.01"
				formControlName="share"
				placeholder="0.25"
				[errorStateMatcher]="matcher"
			/>
			@if (hasError(positionShareCtrl, 'min', 'max')) {
				<mat-error>{{ 'base.form.error.position_share_error' | transloco }}</mat-error>
			} @else if (hasError(positionShareCtrl, 'required')) {
				<mat-error>{{ 'base.form.error.positionShare_required' | transloco }}</mat-error>
			}
		</mat-form-field>
	</lvr-field>

	<!-- Employment Start Field -->
	<lvr-field [label]="'base.field.start' | transloco | appendAsterisk">
		@let startCtrl = form.get('start');
		<mat-form-field lvrInput [lvrError]="hasError(startCtrl, 'matDatepickerParse', 'gracePeriod', 'required')">
			<input
				matInput
				[matDatepicker]="picker"
				formControlName="start"
				[placeholder]="'base.field.select_please' | transloco"
				[max]="maxStartDate"
				[errorStateMatcher]="matcher"
			/>
			<mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
			<mat-datepicker #picker></mat-datepicker>
			@if (hasError(startCtrl, 'matDatepickerParse')) {
				<mat-error>{{ 'base.form.error.date_format_invalid' | transloco: { format: dateFormatHint } }}</mat-error>
			} @else if (hasError(startCtrl, 'gracePeriod')) {
				<mat-error>{{ 'base.form.error.max_grace_period_error' | transloco: { years: gracePeriodYears } }}</mat-error>
			} @else if (hasError(startCtrl, 'required')) {
				<mat-error>{{ 'base.form.error.employment_start_required' | transloco }}</mat-error>
			} @else {
				<mat-hint>{{ dateFormatHint }}</mat-hint>
			}
		</mat-form-field>
	</lvr-field>

	<!-- Employment End Field -->
	<lvr-field [label]="'base.field.end' | transloco">
		@let endCtrl = form.get('end');
		<mat-form-field lvrInput [lvrError]="hasError(endCtrl, 'matDatepickerParse', 'dateRangeExceeded', 'required')">
			<input
				matInput
				[matDatepicker]="endPicker"
				formControlName="end"
				[placeholder]="'base.field.select_please' | transloco"
				[errorStateMatcher]="matcher"
				[min]="minEndDate()"
			/>
			<mat-datepicker-toggle matIconSuffix [for]="endPicker"></mat-datepicker-toggle>
			<mat-datepicker #endPicker></mat-datepicker>
			@if (hasError(endCtrl, 'matDatepickerParse')) {
				<mat-error>{{ 'base.form.error.employment_end_required' | transloco }}</mat-error>
			} @else if (hasError(endCtrl, 'dateRangeExceeded')) {
				<mat-error>{{ 'base.form.error.end_date_error' | transloco }}</mat-error>
			} @else if (hasError(endCtrl, 'required')) {
				<mat-error>{{ 'base.form.error.employment_end_required' | transloco }}</mat-error>
			} @else {
				<mat-hint>{{ dateFormatHint }}</mat-hint>
			}
		</mat-form-field>
	</lvr-field>

	<p class="required-hint">{{ 'base.form.required' | transloco }}</p>

	<lvr-default-actions
		[disableSave]="form.invalid || !canEditPositionSharesPermission()"
		(save)="submit()"
		(cancelSave)="handleCancelEdit()"
	>
		<lvr-restore-actions entityType="user" [entityId]="draftId()"></lvr-restore-actions>
	</lvr-default-actions>
</form>
